import { render, staticRenderFns } from "./Villas.vue?vue&type=template&id=6feb3b80&"
import script from "./Villas.vue?vue&type=script&lang=js&"
export * from "./Villas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports